import * as TYPES from '../constants';

import { connectRouter } from 'connected-react-router';
import history from 'utils/history';

export const router = connectRouter(history);

export function loader(state = false, action: any) {
	if (action.type === TYPES.SET_LOADER) {
		return action.value;
	}

	return state;
}

export function title(state = '', action: any) {
	if (action.type === TYPES.SET_TITLE) {
		return action.value;
	}

	return state;
}

export function user(state = null, action: any) {
	if (action.type === TYPES.SET_USER) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null;
	}

	return state;
}

export function business(state = null, action: any) {
	if (action.type === TYPES.SET_BUSINESS) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null;
	}

	return state;
}

export function token(state = '', action: any) {
	if (action.type === TYPES.SET_TOKEN) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return '';
	}

	return state;
}

export function language(state = 'pt', action: any) {
	if (action.type === TYPES.SET_LANGUAGE) {
		return action.value;
	}

	return state;
}

export function mobile(state = window.innerWidth <= 768, action: any) {
	if (action.type === TYPES.SET_MOBILE) {
		return action.value;
	}

	return state;
}

export function nav(state = false, action: any) {
	if (action.type === TYPES.SET_NAV) {
		return action.value;
	}

	return state;
}

export function breadcrumb(state: any = null, action: any) {
	if (action.type === TYPES.SET_BREADCRUMB) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null;
	}

	return state;
}

export function updateCrumb(state: any = null, action: any) {
	if (action.type === TYPES.SET_UPDATER) {
		return { updateCrumb: action.dispatch };
	}

	if (action.type === TYPES.UPDATE_CRUMB) {
		if (state?.updateCrumb) {
			state?.updateCrumb();
		}
	}

	return state;
}

export function notificationToken(state = "", action: any) {
	if (action.type === TYPES.SET_NOTIFICATION_TOKEN) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null;
	}

	return state;
}

export function pagesModal(state = "", action: any) {
	if (action.type === TYPES.SET_PAGES_MODAL) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return "";
	}

	return state;
}

export function firebaseNotifications(state = true, action: any) {
	if (action.type === TYPES.SET_FIREBASE_NOTIFICATIONS) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return true;
	}

	return state;
}

// DND ("do not disturb", psychologists portal): `until` is a UTC timestamp in ms, null when inactive.
// Persisted by redux-persist on purpose so a refresh keeps it; cleared on logout.
export function dnd(state: { until: number | null } = { until: null }, action: any) {
	if (action.type === TYPES.SET_DND) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return { until: null };
	}

	return state;
}

export function pendingCalls(state = null, action: any) {
	if (action.type === TYPES.SET_PENDING_CALLS) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null;
	}

	return state;
}

export function unreadChatMessages(state = false, action: any) {
	if (action.type === TYPES.SET_UNREAD_MESSAGES) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return false;
	}

	return state;
}

// VIDEO CALLS
export function videoSettings(state = null, action: any) {
	if (action.type === TYPES.SET_VIDEO_SETTINGS) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null;
	}

	return state;
}

// Presence of the other party per consultation id (socket `consultation-presence` + GET /video-calls presence).
// Live state: not persisted (see reducers/index.ts) and cleared on logout.
export function consultationPresence(state: any = {}, action: any) {
	if (action.type === TYPES.SET_CONSULTATION_PRESENCE) {
		const { consultationId, connected, name, at } = action.value || {};
		if (!consultationId) return state;
		return { ...state, [consultationId]: { connected: Boolean(connected), name: name || state[consultationId]?.name || null, at: at || null } };
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return {};
	}

	return state;
}

export function room(state = null, action: any) {
	if (action.type === TYPES.SET_ROOM) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null;
	}

	return state;
}

// AUDIO CALLS
export function audioSettings(state = null, action: any) {
	if (action.type === TYPES.SET_AUDIO_SETTINGS) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null;
	}

	return state;
}

export function audioRoom(state = null, action: any) {
	if (action.type === TYPES.SET_AUDIO_ROOM) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null;
	}

	return state;
}


// CHAT
export function pendingMessages(state = { pending: false, id: null, message: '', data: null }, action: any) {
	if (action.type === TYPES.SET_PENDING_MESSAGES) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return { pending: false, id: null, message: '', data: null };
	}

	return state;
}

export function pendingChats(state = false, action: any) {
	if (action.type === TYPES.SET_PENDING_CHATS) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return false;
	}

	return state;
}

export function acceptedChat(state = { accepted: false, current: null, record: null }, action: any) {
	if (action.type === TYPES.SET_ACCEPTED_CHAT) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return { accepted: false, current: false, record: null };
	}

	return state;
}

export function finishedChat(state = { finished: false, record: null }, action: any) {
	if (action.type === TYPES.SET_FINISHED_CHAT) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return { finished: false, record: null };
	}

	return state;
}

export function toDelete(state = { delete: false, record: null }, action: any) {
	if (action.type === TYPES.SET_TO_DELETE_CHAT) {
		return action.value;
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return { delete: false, record: null };
	}

	return state;
}